import { takeLatest } from 'redux-saga/effects'
import sagas from './sagas'

const sagasList = sagas.map(({ type, saga }) => takeLatest(type, saga))

export default sagasList
